import { ROUTES } from 'base/routes/routes';
import { Route, Routes } from 'react-router-dom';

export const MarketingCampaignRoutes = ({
  PresentReport,
  BCTHTTKH,
}: {
  PresentReport: React.ComponentType;
  BCTHTTKH: React.ComponentType;
}) => (
  <Routes>
    <Route path={ROUTES.MARKETING_CAMPAIGN.PRESENT_REPORT.BASE} element={<PresentReport />} />
    <Route path={ROUTES.MARKETING_CAMPAIGN.THTTKH_REPORT.BASE} element={<BCTHTTKH />} />
  </Routes>
);
